if (!customElements.get('quantity-buy-box')) {
  class QuantityBuyBox extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;

      this.config = JSON.parse(this.querySelector('[data-qbb-config]').textContent);
      this.purchaseName = `qbb-purchase-${this.dataset.sectionId}`;
      this.everyName = `qbb-every-${this.dataset.sectionId}`;

      this.form = this.querySelector('form');
      this.idInput = this.form.querySelector('[name="id"]');
      this.planInput = this.form.querySelector('[data-qbb-plan]');
      this.submitBtn = this.form.querySelector('[name="add"]');
      this.subInput = this.querySelector(`[name="${this.purchaseName}"]`);
      this.everyRow = this.querySelector('[data-qbb-every]');
      this.status = this.querySelector('[data-qbb-status]');
      this.appstleBridge = this.querySelector('[data-qbb-appstle-bridge] input');
      this.afterpay = (this.closest('.js-product') || document).querySelector('square-placement');
      this.picker = (this.closest('.js-product') || document).querySelector('variant-picker');

      this.state = this.readState();
      this.busyLabel = null;

      this.addEventListener('change', this.handleChange.bind(this));
      this.addEventListener('submit', this.handleSubmit.bind(this), true);
      this.addEventListener('on:cart:add', this.handleAdded.bind(this));
      this.addEventListener('on:line-item:change', this.handleAdded.bind(this));
      this.addEventListener('on:cart:error', this.endBusy.bind(this));
      document.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      window.addEventListener('pageshow', this.handlePageShow.bind(this));
      this.guardSubscriptionWidget();
      this.disableUpsellPopup();
      this.render();
      setTimeout(() => this.render());
    }

    readState() {
      const qty = Number(this.querySelector('[name="quantity"]:checked')?.value);
      const variant = String(this.idInput.value);
      return {
        variant: this.config.options[variant] ? variant : String(this.config.initial),
        qty: qty >= 1 && qty <= 3 ? qty : this.config.defaultQty,
        sub: Boolean(this.subInput?.checked),
        plan: this.querySelector(`[name="${this.everyName}"]:checked`)?.value || null,
        missing: Boolean(this.picker?.selectedOptions && !this.picker.variant && !this.picker.preSelection)
      };
    }

    handlePageShow(evt) {
      if (evt.persisted) this.endBusy();
      this.state = this.readState();
      this.render();
    }

    handleVariantChange(evt) {
      if (evt.detail.form !== this.form) return;
      const { variant } = evt.detail;
      this.state.missing = !variant;
      if (variant && this.config.options[String(variant.id)]) {
        this.state.variant = String(variant.id);
        this.state.plan = null;
      }
      this.render();
      if (variant) this.announce();
    }

    handleSubmit() {
      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;
      this.setBusy('Adding…');
      this.busyTimer = setTimeout(() => {
        if (this.submitBtn.getAttribute('aria-disabled') !== 'true') this.endBusy();
      }, 10000);
    }

    handleAdded() {
      this.setBusy('Added to cart');
      this.busyTimer = setTimeout(() => this.endBusy(), 1400);
    }

    setBusy(label) {
      clearTimeout(this.busyTimer);
      this.busyLabel = label;
      this.render();
    }

    endBusy() {
      clearTimeout(this.busyTimer);
      if (!this.busyLabel) return;
      this.busyLabel = null;
      this.render();
    }

    handleChange(evt) {
      const input = evt.target;
      if (input.name === 'quantity') {
        this.state.qty = Number(input.value);
        this.state.plan = null;
      } else if (input.name === this.purchaseName) {
        this.state.sub = input.checked;
      } else if (input.name === this.everyName) {
        this.state.plan = input.value;
      } else {
        return;
      }
      this.render();
      this.announce();
    }

    getSelection() {
      const option = this.config.options[this.state.variant];
      const q = option.q[this.state.qty - 1];
      const closest = option.plans.find((p) => p.id === q.plan) || null;
      const plan = (this.state.plan && option.plans.find((p) => p.id === this.state.plan)) || closest;
      const subAvailable = Boolean(this.config.subscribe && closest);
      const sub =
        this.state.sub && subAvailable
          ? { plan: plan.id, line: plan.every, ...plan.q[this.state.qty - 1] }
          : null;
      return {
        option,
        q,
        plan,
        subAvailable,
        sub,
        total: sub ? sub.total : q.total,
        amount: sub ? sub.amount : q.amount
      };
    }

    render() {
      const sel = this.getSelection();
      const { option } = sel;

      if (this.state.sub && !sel.subAvailable) {
        this.state.sub = false;
        if (this.subInput) this.subInput.checked = false;
      }

      option.q.forEach((q, i) => {
        this.setText(`[data-qbb-price="${i + 1}"]`, q.card);
        this.setText(`[data-qbb-line="${i + 1}"]`, q.line, true);
      });
      this.setText('[data-qbb-off]', option.off ? `${option.off}% off RRP` : '', true);

      this.renderSizeSaving();

      const purchase = this.querySelector('[data-qbb-purchase]');
      if (purchase) {
        purchase.hidden = !sel.subAvailable;
        this.setText('[data-qbb-save]', sel.plan?.save ? ` & save ${sel.plan.save}%` : '');
        if (sel.plan) this.setText('[data-qbb-sub-line]', sel.plan.every);
      }
      this.renderEvery(sel);

      this.idInput.value = this.state.variant;
      this.planInput.value = sel.sub ? sel.sub.plan : '';
      this.planInput.disabled = !sel.sub;
      if (this.appstleBridge && this.busyLabel !== 'Adding…') this.appstleBridge.value = this.planInput.value;

      if (this.afterpay) this.afterpay.setAttribute('data-amount', sel.amount);

      if (this.state.missing) return;

      const label = option.available
        ? this.busyLabel || `Add ${this.state.qty}${sel.sub ? ' · subscribe' : ''} · ${sel.total}`
        : theme.strings.noStock;
      this.submitBtn.dataset.addToCartText = label;
      if (this.submitBtn.textContent !== label) this.submitBtn.textContent = label;
      this.submitBtn.disabled = !option.available;
    }

    renderEvery(sel) {
      if (!this.everyRow) return;
      const { plans } = sel.option;
      this.everyRow.hidden = !sel.sub || plans.length < 2;
      if (this.everyRow.hidden) return;

      const key = plans.map((p) => `${p.id}:${p.label}`).join(',');
      if (key !== this.everyKey) {
        this.everyKey = key;
        const chips = this.everyRow.querySelector('[data-qbb-every-chips]');
        chips.replaceChildren(
          ...plans.map((p) => {
            const chip = document.createElement('label');
            chip.className = 'qbb-every__chip';
            const input = document.createElement('input');
            input.type = 'radio';
            input.className = 'qbb__input';
            input.name = this.everyName;
            input.value = p.id;
            const text = document.createElement('span');
            text.textContent = p.label;
            chip.append(input, text);
            return chip;
          })
        );
      }

      this.everyRow.querySelectorAll(`[name="${this.everyName}"]`).forEach((input) => {
        input.checked = input.value === sel.sub.plan;
      });
    }

    renderSizeSaving() {
      const upsize = this.state.missing ? null : this.config.upsizes[this.state.variant];
      const key = upsize ? `${upsize.index}:${upsize.value}:${upsize.save}` : '';
      if (!this.picker || key === this.sizeSavingKey) return;
      this.sizeSavingKey = key;

      this.picker.querySelectorAll('[data-qbb-size-save]').forEach((el) => el.remove());
      if (!upsize) return;

      const selector = this.picker.querySelectorAll('.option-selector')[upsize.index];
      const input = selector && [...selector.querySelectorAll('input.js-option')].find((el) => el.value === upsize.value);
      const label = input?.nextElementSibling;
      if (!label) return;

      const line = document.createElement('span');
      line.className = 'qbb-size-save';
      line.dataset.qbbSizeSave = '';
      line.setAttribute('aria-hidden', 'true');
      line.textContent = `${upsize.save}% less/day`;
      const spoken = document.createElement('span');
      spoken.className = 'visually-hidden';
      spoken.dataset.qbbSizeSave = '';
      spoken.textContent = `, ${upsize.save}% less per day`;
      label.append(line, spoken);
    }

    setText(selector, text, hideEmpty) {
      const el = this.querySelector(selector);
      if (!el) return;
      if (el.textContent !== text) el.textContent = text;
      if (hideEmpty) el.hidden = !text;
    }

    announce() {
      clearTimeout(this.announceTimer);
      this.announceTimer = setTimeout(() => {
        if (this.state.missing) {
          this.status.textContent = theme.strings.noVariant;
          return;
        }
        const sel = this.getSelection();
        const plan = sel.sub ? `subscribe ${sel.sub.line}` : 'one-time';
        const parts = [`Buy ${this.state.qty}`, sel.option.title, plan, sel.total];
        this.status.textContent = parts.filter(Boolean).join(', ');
      }, 600);
    }

    disableUpsellPopup() {
      window.OCUApi = window.OCUApi || {};
      window.Zipify = window.Zipify || {};
      window.Zipify.OCU = window.Zipify.OCU || { api: window.OCUApi };
      window.Zipify.OCU.api.customAllowUpsellsValidation = () => false;
      window.Zipify.OCU.api.excludeActionButton = 'quantity-buy-box';
    }

    guardSubscriptionWidget() {
      const strip = () => {
        this.querySelectorAll('.appstle_sub_widget:not([data-qbb-appstle-bridge])').forEach((el) => el.remove());
        this.form
          .querySelectorAll('[name="selling_plan"]:not([data-qbb-plan])')
          .forEach((el) => el.remove());
      };
      strip();
      new MutationObserver(strip).observe(this, { childList: true, subtree: true });
    }
  }

  customElements.define('quantity-buy-box', QuantityBuyBox);
}
